// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/cg-load-distribution-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/cg-load-distribution-limits/cg-load-distribution-limits.js';

mount([g0]);
